// @flow

import * as React from "react"
import {connect} from "react-redux"
import {isActionAvailable} from "../../../reducers/shop"
import ClassNames from "classnames"
import type {
  State as ReduxState,
  ShopItemType,
  SearchItem,
  ShopItem,
} from "../../../types"

type Props = {
  t: any,
  selectedSearchItems: $ReadOnlyArray<string>,
  searchItems: $ReadOnlyArray<SearchItem>,
  shopItems: $ReadOnlyArray<ShopItem>,
  onSingle: () => void,
  onMulti: () => void,
  onGroup: () => void,
  onShopProduct: () => void,
}

class ShopAdminComposeActions extends React.Component<Props> {
  static defaultProps = {
    onSingle: () => {},
    onMulti: () => {},
    onGroup: () => {},
    onShopProduct: () => {},
  }

  getClickHandler(type: ShopItemType) {
    switch (type) {
      case "single":
        return this.props.onSingle
      case "multi":
        return this.props.onMulti
      case "group":
        return this.props.onGroup
      case "shop-product":
        return this.props.onShopProduct
      default:
        return () => {}
    }
  }

  renderButton(type: ShopItemType) {
    const {selectedSearchItems, searchItems, shopItems} = this.props
    const isDisabled = !isActionAvailable(
      searchItems,
      selectedSearchItems,
      shopItems,
      type
    )
    const props = {
      disabled: isDisabled,
      onClick: this.getClickHandler(type),
    }
    const className = ClassNames("btn mr-2", {
      "btn-secondary": !isDisabled,
      "btn-outline-primary": isDisabled,
    })
    return (
      <button className={className} type="button" {...props}>
        <span>{type}</span>
      </button>
    )
  }

  render() {
    return (
      <>
        {this.renderButton("single")}
        {this.renderButton("multi")}
        {this.renderButton("group")}
        {this.renderButton("shop-product")}
      </>
    )
  }
}

const mapStateToProps = ({shop}: ReduxState) => ({
  selectedSearchItems: shop.selectedSearchItems,
  searchItems: shop.searchItems,
  shopItems: shop.shopItems,
})

export default connect(mapStateToProps)(ShopAdminComposeActions)
